module.exports = __webpack_public_path__ + "img/caselist13.dd890cb4.jpg";